import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CKEditorComponent } from 'ng2-ckeditor';
import { DndModule } from 'ng2-dnd';

import { FormMediaComponent } from './form-media/form-media.component';
import { TextEditorComponent } from './text-editor/text-editor.component';

import { ImageDirective } from './form-media/image.directive';
import { VideoDirective } from './form-media/video.directive';

import { DateFormatPipe, TimeFormatPipe } from './table/table.pipe';

import { TranslateModule, TranslatePipe, TranslateService } from 'ng2-translate/ng2-translate';
import { FormCategoryComponent } from './form-category/form-category.component';
import { YoutubeThumbPipe } from './form-media/video.pipe';

// imports: imports the module's exports. which are usually
// declarables(components / directives / pipes) and providers.
// in our case the FilterTextModule has a provider.
//
// exports: exports modules AND declarables (components/directives/pipes) that other modules may want to use
// SharedModule does not use CommonModule, but does use FormsModule.
// Even so, we import/export both of these because most other modules will import SharedModule and will need them.
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    DndModule.forRoot(),
    //TranslateModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorComponent,
    FormMediaComponent,
    TextEditorComponent,
    DateFormatPipe,
    TimeFormatPipe,
    TranslateModule,
    TranslatePipe,
    FormCategoryComponent,
    YoutubeThumbPipe,
    TranslateModule,
  ],
  declarations: [
    CKEditorComponent,
    FormMediaComponent,
    TextEditorComponent,
    VideoDirective,
    ImageDirective,
    DateFormatPipe,
    TimeFormatPipe,
    FormCategoryComponent,
    YoutubeThumbPipe,
  ],
  //providers: [TranslateService]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts